import React, { useEffect, useRef, useState } from 'react';
import { HiLink } from 'react-icons/hi';
import { getCreator } from 'utils/creator/creator';
import { getCompany } from 'utils/company/companyService';
import { FaLightbulb } from "react-icons/fa";
import { FaChartLine  } from 'react-icons/fa';
import { FaClipboardList  } from 'react-icons/fa';
import { FaPuzzlePiece } from "react-icons/fa6";
import { MdOutlineSwipe } from "react-icons/md";
import { TbDragDrop2 } from "react-icons/tb";
import {
  Box,
  Text,
  Flex,
  Button,
  Icon,
  List,
  ListItem,
  Img,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Textarea,
  Tooltip,
} from '@chakra-ui/react';
import { IoAlert } from "react-icons/io5";
import { MdPsychology } from "react-icons/md";
import { MdAdd, MdOutlineStickyNote2, MdDelete } from 'react-icons/md';
import { MdAssessment } from "react-icons/md";
import { MdOutlineAssessment } from "react-icons/md";
import { BiSolidDuplicate } from 'react-icons/bi';

import Select from 'react-select';
import Menu from '../components/Navigate';

import StrightConector from '../components/dragNdrop/strightConector';
import { TbHandClick, TbMessages } from 'react-icons/tb';
import { FaAward } from 'react-icons/fa6';

interface PropsDialog {
  reviews?: any;
  id?: number;
  language?: any;
  seq?: any;
  index?: number;
  name?: any;
  handleNDI?: any;
  handleInput?: any;
  handleSelect?: any;
  input?: any;
  getSeq?: any;
  duplicateSeq?: any;
  delSeq?: any;
  characterOption?: any;
  dialogOption?: any;
  voicePoseOption?: any;
  animateBtn?: any;
  setAnimateBtn?: any;
  handleDialogEmotion: any;
  handleDialogVoice: any;
  formData: any;
  alphabet: any;
  setNavigation: any;
  handleBlock: any;
  handleSelectBlock: any;
  handleDialogBlockRoll: any;
  items?: any;
  showSelectBlock?: any;
  setSelectBlock?: any;
  ShowReview?: any;
  validation?: any;
  handleMiniNDI?: any;
  currentseq?: any;
  targetSequence?: any;
  blockOnFocusHanlder: any;
  blockOnBlurHanlder: any;
  showReflectionQuestions:any;
}

const DialogCompo: React.FC<PropsDialog> = ({
  targetSequence,

  seq,
  index,
  name,
  handleInput,

  input,
  getSeq,
  duplicateSeq,
  delSeq,

  animateBtn,

  handleDialogEmotion,
  handleDialogVoice,
  formData,
  handleDialogBlockRoll,

  setNavigation,
  handleBlock,
  handleSelectBlock,
  items,
  handleNDI,
  showSelectBlock,

  validation,
showReflectionQuestions,
  reviews,
  ShowReview,
}) => {

  const scenarioOptions = Array.from({ length: 5 }, (_, i) => ({
  label: `Scenario ${i + 1}`,
  value: `Scenario ${i + 1}`,
}));
  const textareaRef = useRef(null);

//  const [showScenarioCompletion, setshowScenarioCompletion] = useState(false);


  const { isOpen, onOpen, onClose } = useDisclosure();

  const [showLeftButton, setShowLeftButton] = useState(false);
  const customStyles = {
    menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
    control: (provided: any, state: any) => ({
      ...provided,
      borderRadius: '15px',
      borderColor: 'inherit',
      background: 'transparent',
      // height: '45px',
      width: '150px',
      padding: '0 !important',
    }),
  };
  const customStylesAnimate = {
    menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
    control: (provided: any, state: any) => ({
      ...provided,
      borderRadius: '15px',
      // borderColor: validation.animation && '2px solid red,
      background: 'transparent',
      // height: '45px',
      padding: '0 !important',
      width: '150px',
      border: validation?.[`dailogAnimation${seq.input}`] && '2px solid red',
    }),
  };

  const emotionsOptions = [
    { value: 'Talking', label: 'Talking', key: 1 },
    { value: 'Asking', label: 'Asking', key: 2 },
    { value: 'Agreeing', label: 'Agreeing', key: 3 },
    { value: 'Saying no', label: 'Saying no', key: 4 },
    { value: 'Happy', label: 'Happy', key: 5 },
    { value: 'Disappointed', label: 'Disappointed', key: 6 },
    { value: 'Angry', label: 'Angry', key: 7 },
    { value: 'Talking02', label: 'Talking02', key: 9 },
    { value: 'Idle', label: 'Idle', key: 8 },
    { value: 'walk2', label: 'Walk', key: 10 }
  ];

  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    const newOptions = [
      { value: 999999, label: 'Player' },
      { value: 99999, label: 'Narrator' },
       { value: 9999, label: 'Mentor' },
      // {
      //   value: formData.gameNonPlayingCharacterId,
      //   label: formData.gameNonPlayerName,
      // },
      ...(Array.isArray(formData?.gameNonPlayerOption)
  ? formData.gameNonPlayerOption.map((npc: any) => ({
      value: npc.gasId,
      label: npc.name,
    }))
  : []),
    ];

    setOptions(newOptions);
  }, [formData.gameNonPlayingCharacterId, formData.gameNonPlayerName]);
  useEffect(() => {
    const initialOption =
      options.find((option) => {
        // If charValue is numeric
        if (
          !isNaN(input?.[`Dialog${seq.input}`]?.character) &&
          !isNaN(parseInt(input?.[`Dialog${seq.input}`]?.character, 10))
        ) {
          return (
            option.value ===
            parseInt(input?.[`Dialog${seq.input}`]?.character, 10)
          );
        }

        return option.label === formData.gameNonPlayerName;
      }) || null;
    setSelectedOption(initialOption);
  }, [options, seq.input, input]);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto'; // Reset height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [input?.[`Dialog${seq.input}`]?.dialog]);

  const [showcount, setShowcount] = useState<any>('');

  let focusSeqRef: any;
  const justClick = (event: any, seq: any) => {
    if (event.type === 'click') {
      focusSeqRef = document.getElementsByClassName(seq.id);
      const element = focusSeqRef?.[0];

      if (element) {
        element.classList.remove('non-caret');
        element.removeAttribute('readonly');
        element.focus();
      }
    }
  };

  const handleMiniNDInewblock = (value?: any, seq?: any, i?: any) => {
    handleNDI(value);
    const maxInputItem = items.reduce(
      (max: any, item: any) => (item.input > max.input ? item : max),
      items[0],
    );
    let input = maxInputItem?.input ? maxInputItem.input + 1 : 1;
    if (value != '') {
      handleSelectBlock(
        { value: input },
        input,
        `Dialog${seq.input}`,
        `Dialog${seq.input}`,
      );
    }
  };

  const MiniBox3 = (props: {
    seq?: any;
    i?: number;
    name?: any;
    bodyRef?: any;
  }) => {
    const { seq, i, name, bodyRef } = props;
    return (
      <Box
        position={'absolute'}
        background={'#fff'}
        p={'10px'}
        boxShadow={'1px 1px 17px #69627914'}
        borderRadius={'8px'}
        zIndex={99}
        className="MiniShowBox"
      >
        <List cursor={'pointer'}>
                 <ListItem
                   onClick={() => handleMiniNDInewblock('Note', seq, i)}
                   p={'10px'}
                   display={'flex'}
                   alignItems={'center'}
                   borderBottom={'2px solid #f1f1f170'}
                 >
                   <Icon as={MdOutlineStickyNote2} mr={'10px'} color={'#3311db'} />
                   Note
                 </ListItem>
       
                 <ListItem
                   onClick={() => handleMiniNDInewblock('Dialog', seq, i)}
                   p={'10px'}
                   display={'flex'}
                   alignItems={'center'}
                   borderBottom={'2px solid #f1f1f170'}
                 >
                   <Icon as={TbMessages} mr={'10px'} color={'#3311db'} />
                   Dialog
                 </ListItem>
                 <ListItem
                   onClick={() => handleMiniNDInewblock('Interaction', seq, i)}
                   p={'10px'}
                   display={'flex'}
                   alignItems={'center'}
                 >
                   <Icon as={TbHandClick} mr={'10px'} color={'#3311db'} />
                   Interaction
                 </ListItem>
                 <ListItem
                   onClick={() => handleMiniNDInewblock('Link', seq, i)}
                   p={'10px'}
                   display={'flex'}
                   alignItems={'center'}
                   borderBottom={'2px solid #f1f1f170'}
                 >
                   <Icon as={HiLink} mr={'10px'} color={'#3311db'} />
                   Link
                 </ListItem>
                 {showReflectionQuestions && (
                   <>
                     <ListItem
                       onClick={() => handleMiniNDInewblock('Reflection', seq, i)}
                       p={'10px'}
                       display={'flex'}
                       alignItems={'center'}
                       borderBottom={'2px solid #f1f1f170'}
                     >
                       <Icon as={MdPsychology} mr={'10px'} color={'#3311db'} />
                       Reflection
                     </ListItem>
       
                     <ListItem
                       onClick={() => handleMiniNDInewblock('Overview', seq, i)}
                       p={'10px'}
                       display={'flex'}
                       alignItems={'center'}
                       borderBottom={'2px solid #f1f1f170'}
                     >
                       <Icon as={FaClipboardList} mr={'10px'} color={'#3311db'} />
                       Overview
                     </ListItem>
                     <ListItem
                       onClick={() => handleMiniNDInewblock('KeyInsights', seq, i)}
                       p={'10px'}
                       display={'flex'}
                       alignItems={'center'}
                       borderBottom={'2px solid #f1f1f170'}
                     >
                       <Icon as={FaChartLine} mr={'10px'} color={'#3311db'} />
                       KeyInsights
                     </ListItem>
                      
                     <ListItem
                       onClick={() => handleMiniNDInewblock('PreAssessment', seq, i)}
                       p={'10px'}
                       display={'flex'}
                       alignItems={'center'}
                       borderBottom={'2px solid #f1f1f170'}
                     >
                       <Icon as={MdAssessment} mr={'10px'} color={'#3311db'} />
                       PreAssessment
                     </ListItem>
                     <ListItem
                       onClick={() => handleMiniNDInewblock('PostAssessment', seq, i)}
                       p={'10px'}
                       display={'flex'}
                       alignItems={'center'}
                       borderBottom={'2px solid #f1f1f170'}
                     >
                       <Icon as={MdOutlineAssessment} mr={'10px'} color={'#3311db'} />
                       PostAssessment
                     </ListItem>
                     <ListItem
            onClick={() => handleMiniNDInewblock('WehaveChoose', seq, i)}
            p={'10px'}
            display={'flex'}
            alignItems={'center'}
            borderBottom={'2px solid #f1f1f170'}
          >
            <Icon as={FaPuzzlePiece} mr={'10px'} color={'#3311db'} />
            WehaveChoose
          </ListItem>
                     <ListItem
            onClick={() => handleMiniNDInewblock('SwipeMiniGame', seq, i)}
            p={'10px'}
            display={'flex'}
            alignItems={'center'}
            borderBottom={'2px solid #f1f1f170'}
          >
            <Icon as={MdOutlineSwipe} mr={'10px'} color={'#3311db'} />
            Swipe
          </ListItem>
                     <ListItem
            onClick={() => handleMiniNDInewblock('DragForNow', seq, i)}
            p={'10px'}
            display={'flex'}
            alignItems={'center'}
            borderBottom={'2px solid #f1f1f170'}
          >
            <Icon as={TbDragDrop2} mr={'10px'} color={'#3311db'} />
            Drag For Now 
          </ListItem>
                   </>
                 )}
                 {formData?.gameScenarioCompletion === 'true' && (
                   <ListItem
                     onClick={() =>
                       handleMiniNDInewblock('ScenarioCompletion', seq, i)
                     }
                     p={'10px'}
                     display={'flex'}
                     alignItems={'center'}
                     borderBottom={'2px solid #f1f1f170'}
                   >
                     <Icon as={FaAward} mr={'10px'} color={'#3311db'} />
                     ScenarioCompletion
                   </ListItem>
                 )}
               </List>
      </Box>
    );
  };

  return (
    <>
      <Flex
        // className="block-compo"
        borderRadius={'12px'}
        mb={'20px'}
        padding={'10px 0'}
        alignItems={'start'}
        overflowX={'auto'}
        overflowY={'hidden'}
        className="scroll_hide"
        marginBottom={'0px'}
        style={{
          backgroundColor: ShowReview
            ? reviews &&
              reviews.find((item: any) => {
                const tabAttributeValue = `${seq?.questNo}@${seq?.input}`;
                const isMatched = item?.tabAttributeValue === tabAttributeValue;
                return isMatched;
              })
              ? '#E2E8F0'
              : ''
            : '',
        }}
      >
        <Box className="block-action-icons">
          <Tooltip hasArrow label="Choose New Block">
            <div>
              <Icon
                as={MdAdd}
                transitionDelay={'0s !important'}
                fontSize={'18px'}
                color={'grey'}
                mr={'10px'}
                cursor={'pointer'}
                onClick={() => getSeq(seq, index, name)}
              />
            </div>
          </Tooltip>
          <Tooltip hasArrow label="Duplicate">
            <div>
              <Icon
                as={BiSolidDuplicate}
                transitionDelay={'0.1s !important'}
                fontSize={'18px'}
                color={'grey'}
                mr={'10px'}
                cursor={'pointer'}
                onClick={() =>
                  duplicateSeq(seq, index, name, input?.[`Dialog${seq.input}`])
                }
              />
            </div>
          </Tooltip>
          <Tooltip hasArrow label="Delete Dialog">
            <div>
              <Icon
                as={MdDelete}
                transitionDelay={'0.2s !important'}
                fontSize={'18px'}
                color={'grey'}
                cursor={'pointer'}
                onClick={() => delSeq(seq, index, name)}
              />
            </div>
          </Tooltip>
        </Box>
        <Box
          mr={'10px'}
          w={'50px'}
          fontSize={'17px'}
          color={'#1b2559'}
          fontWeight={'700'}
        >
          {seq.id}
        </Box>
        <Box
          className="box-block"
          display={'flex'}
          w={{ base: '100%', lg: 'auto' }}
          alignItems={'center'}
          flexDirection={{ base: 'column', lg: 'row' }}
        >
          <Box m={'0 10px 10px 0'} w={{ base: '100%', lg: '150px' }}>
            <Select
              placeholder={'Character...'}
              id="blockRoll"
              name={`Dialog${seq.input}`}
              menuPortalTarget={document.body}
              styles={customStyles}
              options={options}
              value={selectedOption}
              isSearchable={true}
              onChange={(selectedOption: any) => {
                handleDialogBlockRoll(
                  selectedOption,
                  seq.input,
                  `Dialog${seq.input}`,
                ); //nivetha
              }}
            />
          </Box>
          <Box
            m={'0 10px 0px 0'}
            w={{ base: '100%', lg: '400px' }}
            mb={{ base: '10px', lg: '0px' }}
          >
            <Textarea
              placeholder="Dialog"
              id="Dialog"
              className={`${seq.id}`}
              name={`Dialog${seq.input}`}
              onChange={handleInput}
              onClick={(e) => justClick(e, seq)}
              value={input?.[`Dialog${seq.input}`]?.dialog}
              borderRadius={'18px'}
              style={{
                overflowY: 'hidden',
                border: validation?.[`Dialog${seq?.input}`] && '2px solid red',
              }}
              minHeight="65px"
              height={
                seq?.id === targetSequence?.id ? 'auto' : '65px !important'
              }
              ref={textareaRef} // Add a ref to the textarea
              _focusVisible={{
                borderColor: '#0000',
                border: '1px solid #e5e5e5',
                boxShadow: 'unset',
              }}
              tabIndex={0}
              readOnly={true}
            />
          </Box>
          {parseInt(input?.[`Dialog${seq.input}`]?.character, 10) !== 99999 && (
            <Box mr={'10px'} w={'150px'}>
              <Select
                placeholder={'Animate...'}
                id="Dialog"
                name={`Dialog${seq.input}`}
                menuPortalTarget={document.body}
                styles={customStylesAnimate}
                options={emotionsOptions}
                isSearchable={true}
                isClearable={false}
                isMulti={true}
                value={
                  input?.[`Dialog${seq.input}`]?.animation
                    ? input?.[`Dialog${seq.input}`]?.animation
                        .split(',')
                        .map((value: string) => ({
                          // Explicitly specify the type as string
                          value,
                          label: value,
                        }))
                    : []
                }
                onChange={(selectedOption: any) =>
                  handleDialogEmotion(selectedOption, seq.input)
                }
              />
            </Box>
          )}

 <Box
  className="scenario-dropdown"
  mb="10px"
  w={{ base: '100%', lg: '200px' }}
>
  <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
    Select Scenario
  </Text>

 <Select
  placeholder="Select Scenario"
  options={scenarioOptions}
  // value={input?.[`Note${seq.input}`]?.scenario || null}

   value={
  scenarioOptions.find(
    (opt) =>
      opt.value === input?.[`Dialog${seq.input}`]?.scenario
  ) || null
}
   styles={{
      ...customStyles,
      control: (provided: any) => ({
        ...provided,
        borderRadius: '12px',
        minHeight: '36px',
      }),
    }}
  onChange={(option: any) =>
                handleInput({
                  name: `Dialog${seq.input}`,
                  value: {
                    // scenario: option,
                    scenario: option?.value,

                  },
                })
              }
  isSearchable={false}
  menuPortalTarget={document.body}
/>

</Box>
          <Box
            className="navigation-icon"
            mr={'40px'}
            mb={{ base: '10px', lg: '0px' }}
          >
            <Flex>
              <Box>
                <Tooltip hasArrow label="Add Navigations" placement="top">
                  <div>
                    <Menu
                      tabState={'leadDialog'}
                      id={seq.input}
                      for={`Dialog${seq.input}`}
                      setNavigation={setNavigation}
                      handleBlock={handleBlock}
                      items={items}
                      seq={seq}
                    />
                  </div>
                </Tooltip>
              </Box>
              <Box
                ml={'4px'}
                cursor={'pointer'}
                display={
                  input?.[`Dialog${seq.input}`]?.DialogleadShow
                    ? 'block'
                    : 'none'
                }
                style={{ width: '170px' }}
              >
                {input?.[`Dialog${seq.input}`]?.DialogleadShow ===
                  'New Block' &&
                !input?.[`Dialog${seq.input}`]?.Dialognavigate ? (
                  // Render content for New Block
                  <>
                    <MiniBox3 seq={seq} i={index} />
                  </>
                ) : input?.[`Dialog${seq.input}`]?.DialogleadShow ===
                    'Select Block' &&
                  !input?.[`Dialog${seq.input}`]?.Dialognavigate ? (
                  // Render select tag for Select Block
                  <Select
                    placeholder={'Blocks...'}
                    id="Dialog"
                    name={`Dialog${seq.input}`}
                    menuPortalTarget={document.body}
                    styles={customStyles}
                    options={showSelectBlock.filter(
                      (option: any) => option.value !== seq.input,
                    )}
                    isSearchable={true}
                    className="react-select"
                    value={
                      showSelectBlock.find(
                        (option: any) =>
                          option.value ==
                          input?.[`Dialog${seq.input}`]?.Dialognavigate,
                      ) || null
                    }
                    onChange={(e: any) =>
                      handleSelectBlock(
                        e,
                        seq.input,
                        `Dialog${seq.input}`,
                        `Dialog${seq.input}`,
                      )
                    }
                  />
                ) : (
                  // Render content for the 'else' condition
                  <>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <StrightConector
                        name={
                          input?.[`Dialog${seq.input}`]?.DialogleadShow ===
                          'New Block'
                            ? showSelectBlock.find(
                                (option: any) =>
                                  option.value ==
                                  input?.[`Dialog${seq.input}`]?.Dialognavigate,
                              )?.label
                            : input?.[`Dialog${seq.input}`]?.DialogleadShow ===
                              'Select Block'
                            ? showSelectBlock.find(
                                (option: any) =>
                                  option.value ==
                                  input?.[`Dialog${seq.input}`]?.Dialognavigate,
                              )?.label
                            : input?.[`Dialog${seq.input}`]?.Dialognavigate
                        }
                      />
                    </div>
                  </>
                )}
              </Box>
            </Flex>
          </Box>
          {100 < 50 && (
            <Box w={'100px'} mr={'10px'}>
              <Select
                placeholder={'Voice...'}
                id="Dialog"
                name={`Dialog${seq.input}`}
                menuPortalTarget={document.body}
                styles={customStyles}
                options={emotionsOptions}
                isSearchable={true}
                value={
                  emotionsOptions.find(
                    (option) =>
                      option.value === input?.[`Dialog${seq.input}`]?.voice,
                  ) || null
                }
                onChange={(selectedOption: any) =>
                  handleDialogVoice(selectedOption, seq.input)
                }
              />
            </Box>
          )}
          {animateBtn && <Img src="" alt="animate" h={'30px'} w={'30px'} />}
        </Box>
      </Flex>

      <Modal blockScrollOnMount={false} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Animation</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text fontWeight="bold" mb="1rem">
              Animation Images
            </Text>
            {}
            <Img src="" />
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default DialogCompo;
